import { render } from "./ManageVehicle.vue?vue&type=template&id=6d90aaa4"
import script from "./ManageVehicle.vue?vue&type=script&lang=js"
export * from "./ManageVehicle.vue?vue&type=script&lang=js"

import "./ManageVehicle.vue?vue&type=style&index=0&id=6d90aaa4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__